import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsLoggedInUser } from '@kurtosys/types/query/options/IQueryOptionsLoggedInUser.js';

import { BaseQuery } from './base/BaseQuery.js';

export class LoggedInUserQuery extends BaseQuery<IQueryOptionsLoggedInUser> {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
	initialize(executionOptions: IExecutionOptions): void {}
	getOptions(): IQueryOptionsLoggedInUser {
		const { key, code, options = {} } = this.queryOptions;
		return {
			key,
			code,
			...(options.loggedInUser || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { key, code } = this.options;
		const loggedInUser = this.getLoggedInUser(executionOptions);
		if (loggedInUser) {
			if (code) {
				let result = loggedInUser[code];
				if (key && Array.isArray(result)) {
					result = result.map((element) => element[key]);
				}
				return result;
			}
			return loggedInUser as any;
		}
		return;
	}
}
